import content_announce_list from './announce-list';
import content_announce_add from './announce-add';
import content_announce_edit from './announce-edit';
import content_announce_detail from './announce-detail';

export default {
    content_announce_list,
    content_announce_add,
    content_announce_edit,
    content_announce_detail,
};
